import { Bell } from "lucide-react";

const NOTIF_OPTIONS = [
  { key: "low_stock", label: "Alertes stock bas" },
  { key: "new_orders", label: "Nouvelles commandes" },
  { key: "daily_sales", label: "Rappel ventes quotidien" },
  { key: "weekly_summary", label: "Emails resume hebdomadaire" },
];

export function SettingsNotifications({ notifs, accent, onChange }) {
  const toggle = (key) => onChange({ ...notifs, [key]: !notifs[key] });

  return (
    <div className="s-card" data-testid="notifications-section">
      <div className="s-card-header">
        <div className="s-card-title-row">
          <Bell size={18} style={{ color: accent }} />
          <h2 className="s-card-title">Notifications</h2>
        </div>
      </div>
      {NOTIF_OPTIONS.map(n => (
        <div key={n.key} className="s-toggle-row" data-testid={`toggle-${n.key}`}>
          <span className="s-toggle-label">{n.label}</span>
          <button className={`s-toggle ${notifs[n.key] ? 'on' : ''}`} onClick={() => toggle(n.key)}>
            <span className="s-toggle-knob" />
          </button>
        </div>
      ))}
    </div>
  );
}
